import { STORAGE_PREFIX } from "../constants";
import { DataState } from "../types/enums";
import { loadFromStorage, removeFromStorage, saveToStorage, } from "../utils/storage";
import Subscribable from "./Subscribable";
const DEFAULT_VERSION = 1;
class DataStore extends Subscribable {
    constructor(storageKey, maxCacheAge, version = DEFAULT_VERSION) {
        super();
        this._entries = new Map();
        this._localStorageLoaded = false;
        this._storageKey = storageKey;
        this._maxStorageAge = maxCacheAge;
        this._version = version;
    }
    loadLocalStorage() {
        this._localStorageLoaded = true;
        const existingData = loadFromStorage(STORAGE_PREFIX + this._storageKey, Map);
        if (existingData === null)
            return;
        const now = new Date();
        existingData.forEach((entry, key) => {
            var _a;
            if (!entry.fetchedAt ||
                this._version > ((_a = entry.version) !== null && _a !== void 0 ? _a : DEFAULT_VERSION))
                return;
            const age = (+now - +new Date(entry.fetchedAt)) / 1000 / 60;
            entry.state =
                age > this._maxStorageAge ? DataState.Waiting : DataState.Fetched;
            this._entries.set(key, entry);
        });
    }
    saveLocalStorage() {
        const storage = {};
        this._entries.forEach((value, key) => {
            if (value.data && Object.keys(value.data).length !== 0) {
                storage[key] = Object.assign(Object.assign({}, value), { version: this._version });
            }
        });
        if (Object.keys(storage).length !== 0) {
            saveToStorage(STORAGE_PREFIX + this._storageKey, storage);
        }
        else {
            removeFromStorage(STORAGE_PREFIX + this._storageKey);
        }
    }
    setState(key, state) {
        const entry = this.get(key) || {};
        entry.state = state;
        return this.set(key, entry);
    }
    setData(key, data) {
        const entry = this.get(key) || {};
        entry.state = DataState.Fetched;
        entry.fetchedAt = new Date();
        entry.data = data;
        return this.set(key, entry);
    }
    set(key, entry) {
        this._entries.set(key, entry);
        this.invoke(key, entry);
        this.saveLocalStorage();
        return entry;
    }
    get(key) {
        if (!this._localStorageLoaded) {
            this.loadLocalStorage();
        }
        if (this._entries.has(key)) {
            return this._entries.get(key);
        }
        const entry = {
            state: DataState.Waiting,
        };
        this._entries.set(key, entry);
        return entry;
    }
    isWaiting(key) {
        const entry = this.get(key);
        if (entry.state === DataState.Waiting) {
            entry.state = DataState.Fetching;
            return true;
        }
        return false;
    }
}
export default DataStore;
//# sourceMappingURL=DataStore.js.map